<div>
	<ng-container *ngFor="let item of elementItems">
		<h3>{{ item.label | translate }}</h3>
		<div class="channel-group-block">
			<bb-form-element theme="light-v2" [hideLabel]="true">
				<bb-radio-list [valueOnlyModel]="true" mode="image" [ngModelOptions]="{standalone: true}" [noWrap]="true"
					[options]="item.options" maxColumns="3" (ngModelChange)="elementChosen($event)" [(ngModel)]="element">
				</bb-radio-list>
			</bb-form-element>
			<mat-hint *ngIf="item.warning">{{ item.warning | translate }}</mat-hint>
		</div>
	</ng-container>

	<div id="close-add-channel-button" (click)="close()">
		<button mat-fab color="primary">
			<i class="far fa-plus fa-xl "></i>
		</button>
	</div>
</div>
